import React from 'react';
import ResearchPrompt from './ResearchPrompt';

const FormattedInsight = ({ text }) => {
  const lines = text.split('\n').filter(line => line.trim() !== '');
  const mainTitle = lines[0] || '';
  const bodyText = lines.slice(1).join('\n');

  // Group text into concepts. A concept is a title line followed by a description line.
  const concepts = bodyText.split('\n').reduce((acc, line, index, arr) => {
    // Check if the line looks like a title (doesn't start with whitespace)
    if (line.trim() !== '' && line.charAt(0) !== ' ') {
      // If the next line is a description, group them
      const description = arr[index + 1] && arr[index + 1].charAt(0) === ' ' ? arr[index + 1].trim() : '';
      acc.push({
        fullText: `${line.trim()} ${description}`,
        title: line.replace(/\*\*/g, '').trim()
      });
    }
    return acc;
  }, []);

  return (
    <div className="formatted-insight">
      <h4>{mainTitle}</h4>
      <ul>
        {concepts.map((concept, index) => (
          <li key={index}>
            <span className="concept-text">{concept.fullText}</span>
            <ResearchPrompt concept={concept.title} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FormattedInsight;